require('./Conditions.scss');
import React from 'react';
import Modal from 'react-modal';
import RegistrationService from './registration-service';
import PropTypes from 'prop-types';

class Conditions2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            conditions: '',
        };
    }

    componentDidMount() {
        //Modal.setAppElement('body');
        this.loadData();
    }

    loadData() {
        return RegistrationService.getConditions().then((conditions) => {
            let conditionsDOMNodes = document.createRange().createContextualFragment(conditions);
            let queryForArticleTag = conditionsDOMNodes.querySelector('article');
            let conditionsContent = queryForArticleTag.innerHTML;
            return this.setState({ conditions: conditionsContent });
        });
    }

    modalProps = {
        triggerText: "Launch the Modal!"
      };
    
    modalContent = (
        <React.Fragment>
          <p>
            Press <code>Esc</code> or click Outside the Modal to exit.
          </p>
          <p>
            Pressing Return also exits the Modal if you changed the focus!
          </p>
        </React.Fragment>
      );

    render() {
        return (
            
            
                <Modal
                    className="ReactModal__Content new-address"
                    overlayClassName="ReactModal__Overlay"
                    ariaHideApp={true}
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                    onRequestClose={this.props.closeConditions}
                    contentLabel="Legge til adresse"
                    isOpen={this.props.conditionsMode}
                >
                    <button
                        ref={this.props.buttonRef}
                        aria-label="Close Modal"
                        aria-labelledby="close-modal"
                        className="_modal-close"
                        onClick={this.props.closeConditions}
                        >
                        <span id="close-modal" className="_hide-visual">
                            Close
                        </span>
                        <svg className="_modal-close-icon" viewBox="0 0 40 40">
                            <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
                        </svg>
                    </button>

                    <h1 className="modal-headline">Avtalevilkår for godkjenning</h1>
                    <div className="conditions-container" dangerouslySetInnerHTML={{ __html: this.state.conditions }} />
                    <div className="button-container spacer-bottom-3 spacer-top-3">                       
                        <button
                            className="btn btn-default"
                            onClick={() =>
                                this.props.closeConditions()
                            }
                        >
                            Lukk
                        </button>
                    </div>
                   
                    
                   
                </Modal>
           
        );
    }
}


Conditions2.propTypes = {
    closeConditions: PropTypes.func,
    conditionsMode: PropTypes.bool
};

export default Conditions2;
